import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const tileVariants = {
    hidden: { opacity: 0, scale: 0.96 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
};

const TILE =
    "w-full h-full rounded-[3vh] text-center bg-white shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] p-[2vh_1.6vw] flex flex-col justify-between";
const LABEL =
    "text-[1.3vh] font-bold text-center tracking-[0.15vh] uppercase text-[#7B8290]";

const CACHE_DURATION = 60 * 1000; // 1 минута

function ExchangeRateSlide() {
    const { t } = useTranslation();
    const [usdKzt, setUsdKzt] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        const cachedFiat = JSON.parse(localStorage.getItem("fiatData"));
        if (cachedFiat && Date.now() - cachedFiat.timestamp < CACHE_DURATION) {
            setUsdKzt(cachedFiat.data.usdKzt);
        } else {
            fetch("https://api.exchangerate-api.com/v4/latest/USD")
                .then((res) => {
                    if (!res.ok) throw new Error();
                    return res.json();
                })
                .then((data) => {
                    const result = { usdKzt: data.rates.KZT };
                    setUsdKzt(result.usdKzt);
                    localStorage.setItem(
                        "fiatData",
                        JSON.stringify({ data: result, timestamp: Date.now() }),
                    );
                })
                .catch(() => setError(true));
        }
    }, []);

    if (error) {
        return (
            <motion.div
                className={TILE}
                variants={tileVariants}
                initial="hidden"
                animate="visible"
            >
                <span className={LABEL}>{t("routeList.currency_label")}</span>
                <span className="text-[1.6vh] font-semibold text-[#7B8290] self-end text-right">
                    {t("routeList.exchange_error")}
                </span>
            </motion.div>
        );
    }

    if (usdKzt === null) {
        return (
            <motion.div
                className={TILE}
                variants={tileVariants}
                initial="hidden"
                animate="visible"
            >
                <span className={LABEL}>{t("routeList.currency_label")}</span>
                <span className="text-[1.6vh] font-semibold text-[#7B8290] self-end">
                    {t("routeList.exchange_loading")}
                </span>
            </motion.div>
        );
    }

    return (
        <motion.div
            className={TILE}
            variants={tileVariants}
            initial="hidden"
            animate="visible"
        >
            <span className={LABEL}>{t("routeList.currency_label")}</span>
            <span className="text-[3.6vh] font-extrabold tracking-tight self-end leading-none">
                {Math.round(usdKzt)}₸
            </span>
        </motion.div>
    );
}

export default ExchangeRateSlide;
